module.exports = __webpack_public_path__ + "images/9faa10e67e477c8cb7fd7555199b70c6.jpg";